import React from 'react';
import { NavLink } from 'react-router-dom';
import { LayoutGrid, Monitor, Smartphone, UserRound } from 'lucide-react';
import { DmpLogo } from '../brand/DmpLogo';
import { BdFlag } from '../brand/BdFlag';
const links = [{
  to: '/',
  label: 'উপস্থাপনা',
  icon: LayoutGrid,
  end: true
}, {
  to: '/mobile',
  label: 'ট্রাফিক পুলিশ মোবাইল অ্যাপ',
  icon: Smartphone,
  end: false
}, {
  to: '/admin',
  label: 'ওয়েব অ্যাডমিন পোর্টাল',
  icon: Monitor,
  end: false
}, {
  to: '/owner',
  label: 'গাড়ির মালিক অ্যাপ',
  icon: UserRound,
  end: false
}];
export function PrototypeTopBar() {
  return <div className="print-hide sticky top-0 z-40 border-b border-border bg-white" data-id="element-741" data-mp="3lzdcpe5ki4dn">
      <div className="flex h-12 items-center gap-3 px-4" data-id="element-742" data-mp="3lxag2b9wtczy">
        <DmpLogo size={28} data-id="element-743" data-mp="3gzqwqwycua15" />
        <p className="hidden text-sm font-semibold text-navy-900 md:block" data-id="element-744" data-mp="3gyftcy8tn4ak">ডিএমপি কিউআর ভিত্তিক সিএনজি ও চালক যাচাই ব্যবস্থা</p>
        <nav className="ml-auto flex items-center gap-1" aria-label="প্রোটোটাইপ নেভিগেশন" data-id="element-745" data-mp="dk3e4g0vzham">
          {links.map(({
          to,
          label,
          icon: Icon,
          end
        }) => <NavLink key={to} to={to} end={end} className={({
          isActive
        }) => `flex items-center gap-1.5 rounded-md px-2.5 py-1.5 text-xs font-medium ${isActive ? 'bg-navy-800 text-white' : 'text-slate-600 hover:bg-slate-100'}`} data-id="element-746" data-mp="3gkm53z0491my">
              <Icon className="h-3.5 w-3.5" data-id="element-747" data-mp="2xtchymxfaecw" />
              <span className="hidden sm:inline" data-id="element-748" data-mp="2xsbaesfm89zx">{label}</span>
            </NavLink>)}
        </nav>
        <span className="hidden items-center gap-1.5 rounded-full border border-amber-200 bg-amber-50 px-2.5 py-1 text-[11px] font-semibold text-amber-700 lg:flex" data-id="element-749" data-mp="32t8r10kz8vzb">
          প্রোটোটাইপ • নমুনা তথ্য
        </span>
        <BdFlag width={22} data-id="element-750" data-mp="2sujelnbuo3qg" />
      </div>
    </div>;
}